module.exports = __webpack_public_path__ + "img/tt.e4a2483f.svg";